export default "__VITE_ASSET__CDIEg3Gp__"